import { visit } from 'unist-util-visit';
import type { Root, Link, Text } from 'mdast';

type DocMap = Record<number, { url: string }>;

interface Options {
  map?: DocMap; 
}

export function docRefPlugin({ map }: Options) {
  const RE = /\[(?:Doc\s+)?((?:\d+(?:-\d+)?)(?:\s*,\s*(?:Doc\s+)?(?:\d+(?:-\d+)?))*)\](?!\d)/g;

  const processText = (node: Text, index: number, parent: any) => {
    if (!parent || !node.value) return;

    const out: (Link | Text)[] = [];
    let last = 0;
    let m: RegExpExecArray | null;

    while ((m = RE.exec(node.value))) {
      if (m.index > last) {
        out.push({ type: 'text', value: node.value.slice(last, m.index) });
      }

      const parts = m[1].split(',').map(s => s.replace(/Doc\s+/i, '').trim());

      parts.forEach((part, i) => {
        if (part.includes('-')) {
          const [start, end] = part.split('-').map(Number);
          if (!isNaN(start) && !isNaN(end) && start <= end) {
            for (let n = start; n <= end; n++) {
              if (map?.[n]) {
                out.push({
                  type: 'link',
                  url: map[n].url || '#',
                  data: { hProperties: { 'data-doc': String(n) } },
                  children: [{ type: 'text', value: String(n) }],
                } as unknown as Link);
              } else {
                out.push({ type: 'text', value: `[${n}]` });
              }
              if (n < end) {
                out.push({ type: 'text', value: ', ' });
              }
            }
          } else {
            out.push({ type: 'text', value: `[${part}]` });
          }
        } else {
          const n = Number(part);
          if (!isNaN(n) && map?.[n]) {
            out.push({
              type: 'link',
              url: map[n].url || '#',
              data: { hProperties: { 'data-doc': String(n) } },
              children: [{ type: 'text', value: String(n) }],
            } as unknown as Link);
          } else {
            out.push({ type: 'text', value: `[${part}]` });
          }
        }

        if (i < parts.length - 1) {
          out.push({ type: 'text', value: ', ' });
        }
      });

      last = m.index + m[0].length;
    }

    if (last < node.value.length) {
      out.push({ type: 'text', value: node.value.slice(last) });
    }

    if (out.length) {
      parent.children.splice(index, 1, ...out);
    }
  };

  return (tree: Root) => {
    visit(
      tree,
      (node) => ['text', 'strong', 'emphasis', 'delete'].includes(node.type),
      (node: any, index, parent) => {
        if (node.type === 'text') {
          processText(node, index!, parent);
        } else if (['strong', 'emphasis', 'delete'].includes(node.type)) {
          node.children.forEach((child: any, childIndex: number) => {
            if (child.type === 'text') {
              processText(child, childIndex, node);
            }
          });
        }
      }
    );
  };
}